import {
  SET_DATA_FOR_RESALE_ASSETS,
  SET_RESALE_ASSET_DETAILS_LOADING,
  GET_RESALE_ITEM_DETAILS_DATA_MFA,
  GET_RESALE_ITEM_DETAILS_DATA_NON_MFA,
  SET_RESALE_ITEM_DETAILS_DATA,
  SET_RESALE_LOADING,
  SET_RESALE_ENQUIRY_SUBMITTING,
  SET_PREVIOUS_RESALE_ENQUIRY,
} from './resale.actionTypes';

const initialState = {
  resaleList: [],
  resaleDataLoading: false,
  enquirySubmittingStatus: {},
  resalePreviousEnquiry: [],
  resaleItemDetails: {},
};

const setResaleList = (state, {data}) => {
  return {
    ...state,
    resaleList: data,
  };
};

const getResaleItemDetailsNonMfa = (state, {data}) => {
  return {
    ...state,
    resaleItemDetails: data,
  };
};

const getResaleItemDetailsMfa = (state, {data}) => {
  return {
    ...state,
    resaleItemDetails: data,
  };
};

const setResaleItemDetails = (state, {data}) => {
  return {
    ...state,
    resaleItemDetails: {...state.resaleItemDetails, data},
  };
};

const setResaleItemDetailsLoading = (state, {assetDetailsLoading}) => {
  return {
    ...state,
    resaleItemsDetailsLoading: assetDetailsLoading,
  };
};

const setResaleDataLoading = (state, {resaleDataLoading}) => {
  return {
    ...state,
    resaleDataLoading: resaleDataLoading,
  };
};

const setResaleEnquirySubmittingStatus = (state, {resaleEnquirySubmitting}) => {
  return {
    ...state,
    enquirySubmittingStatus: resaleEnquirySubmitting,
  };
};

const setPreviousResaleEnquiryData = (state, {data}) => {
  return {
    ...state,
    resalePreviousEnquiry: data,
  };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DATA_FOR_RESALE_ASSETS:
      return setResaleList(state, action);
    case GET_RESALE_ITEM_DETAILS_DATA_MFA:
      return getResaleItemDetailsMfa(state, action);
    case GET_RESALE_ITEM_DETAILS_DATA_NON_MFA:
      return getResaleItemDetailsNonMfa(state, action);
    case SET_RESALE_ITEM_DETAILS_DATA:
      return setResaleItemDetails(state, action);
    case SET_RESALE_ASSET_DETAILS_LOADING:
      return setResaleItemDetailsLoading(state, action);
    case SET_RESALE_LOADING:
      return setResaleDataLoading(state, action);
    case SET_RESALE_ENQUIRY_SUBMITTING:
      return setResaleEnquirySubmittingStatus(state, action);
    case SET_PREVIOUS_RESALE_ENQUIRY:
      return setPreviousResaleEnquiryData(state, action);
    default:
      return state;
  }
};

export default reducer;
